import IconServices from './IconServices';

export default IconServices;
